/*
 * @Author: zhaoyu zhaoyu@belink.com
 * @Date: 2022-09-01 15:03:35
 * @LastEditors: zhaoyu zhaoyu@belink.com
 * @LastEditTime: 2022-09-07 21:23:08
 * @FilePath: /pscd-portal-new-workbench/packages/clients/src/apis/codetable.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { IAjaxConfig } from '../helpers';
export class EnumApiIdass {
  /**
   * @dec
   * @method get 获取菜单
   * @params
   */
  readonly idass_get_menu_list: IAjaxConfig = {
    url: '/api/gateway/org-idaas-aggr/public/v1/main/permission/get',
    method: 'get',
  };
  /**
   * @dec
   * @method get 获取工作台/个人中心菜单
   * @params
   */
  readonly idass_get_personal_menu_list: IAjaxConfig = {
    url: '/api/gateway/org-idaas-aggr/v1/permission/get',
    method: 'get',
    loading: true,
    immediatlyCloseLoading: true,
  };
  /**
   * 菜单懒加载
   * @type {IAjaxConfig}
   * @memberof EnumApiIdass
   */
  readonly idass_get_menu_lazy: IAjaxConfig = {
    url: '/api/gateway/org-idaas-aggr/public/v1/menu/lazy/get',
    method: 'get',
    body: {
      parentId: 0,
      // depth: 0,
      menuType: 'main',
      // allLevel: 2,
    },
  };
  /**
   * 云学堂权限
   * @type {IAjaxConfig}
   * @memberof EnumApiIdass
   */
  readonly idass_get_yxt_permission: IAjaxConfig = {
    url: '/api/gateway/org-idaas-aggr/v1/yxt/menu/permission/get',
    method: 'get',
  };

  /**
   * 是否弹出法务弹窗
   * @type {IAjaxConfig}
   * @memberof EnumApiIdass
   */
  readonly idass_get_protect_legalScreen: IAjaxConfig = {
    url: '/api/gateway/idaas-protect/legal/screen/get',
    method: 'get',
  };

  /**
   * 记录法务弹窗确认时间
   * @type {IAjaxConfig}
   * @memberof EnumApiIdass
   */
  readonly idass_save_protect_legalScreen: IAjaxConfig = {
    url: '/api/gateway/idaas-protect/legal/screen/save',
    method: 'post',
  };

  /**
   * SMB快速注册
   * @type {IAjaxConfig}
   * @memberof EnumApiIdass
   */
  readonly orgidass_smb_register: IAjaxConfig = {
    url: '/api/gateway/org-idaas-aggr/public/smb/easy/register',
    method: 'post',
  };

  /**
   * @dec
   * @method get 判断LCIC AI伙伴助手是否处于停机状态
   * @params
   */
  readonly idass_lcic_shutdown: IAjaxConfig = {
    url: '/api/gateway/idaas/public/v1/xz/shutdown/tmp',
    method: 'get',
  };
}
